import { FC, ReactElement } from 'react';

import './ProductPriceSkeletons.scss';

interface ProductPriceSkeletonsProps {
    className?: string;
}

export const ProductPriceSkeletons: FC<ProductPriceSkeletonsProps> = ({
    className = '',
}): ReactElement => (
    <div className={`product-price-skeletons ${className}`} />
);
